export default {
  qingping_particle_sensor: '青萍颗粒物传感器',
  design: '外观',
  measurement_range: '量程',
  specs: '规格',
  in_the_box: '包装清单',
  size: '尺寸',
  color: '颜色',
  size_value: '49.5 × 37 × 11.8 毫米',
  color_value: '银色',
  pm25_pm10: 'PM2.5/PM10',
  pm_range: '0 ~ 999 μg/m³',
  name: '产品名称',
  weight: '产品重量',
  weight_value: '26 克',
  mm_unit: '毫米'
} 